/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RouterCsrDto } from '../../models/router-csr-dto';

export interface ReceiveConfig$Params {
  vendor: string;
      body?: RouterCsrDto
}

export function receiveConfig(http: HttpClient, rootUrl: string, params: ReceiveConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, receiveConfig.PATH, 'post');
  if (params) {
    rb.path('vendor', params.vendor, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    })
  );
}

receiveConfig.PATH = '/api/{vendor}/router/config';
